import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { INTEGRATIONS_HUB, dataSourceInstancePath } from "./paths";

export const LegacyDataSourcesRedirect: React.FC = () => {
  const location = useLocation();
  return (
    <Navigate
      to={`${INTEGRATIONS_HUB}${location.search}${location.hash}`}
      replace
    />
  );
};

export const LegacyDataSourceIdRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  if (!id) {
    return (
      <Navigate
        to={`${INTEGRATIONS_HUB}${location.search}${location.hash}`}
        replace
      />
    );
  }
  return (
    <Navigate
      to={`${dataSourceInstancePath(id)}${location.search}${location.hash}`}
      replace
    />
  );
};
